export default __webpack_public_path__ + "media/images/icons/icon_person_add-d9557536647bdd6fc5a2af1e8e7fd352.svg";